// Códigos de ICMS que o emissor gera hoje (F0a). Espelho de
// backend/app/services/codigos_fiscais.py — o backend recusa qualquer outro.
// CRT 1 e 4 usam CSOSN; os demais regimes, CST.

export const CSOSN_OPTS = [
  { codigo: '101', descricao: 'Tributada pelo Simples Nacional com permissão de crédito' },
  { codigo: '102', descricao: 'Tributada pelo Simples Nacional sem permissão de crédito' },
  { codigo: '103', descricao: 'Isenção do ICMS no Simples Nacional para faixa de receita bruta' },
  { codigo: '201', descricao: 'Tributada com permissão de crédito e cobrança do ICMS por ST' },
  { codigo: '202', descricao: 'Tributada sem permissão de crédito e cobrança do ICMS por ST' },
  { codigo: '203', descricao: 'Isenção do ICMS para faixa de receita bruta e cobrança do ICMS por ST' },
  { codigo: '300', descricao: 'Imune' },
  { codigo: '400', descricao: 'Não tributada pelo Simples Nacional' },
  { codigo: '500', descricao: 'ICMS cobrado anteriormente por ST (substituído) ou por antecipação' },
  { codigo: '900', descricao: 'Outros' },
];

// F0c/F0d: 10, 20, 30, 51, 70 e 90 (e os CSOSN 202/203) passaram a ser gerados,
// com ST, redução, diferimento e FCP do cadastro do produto (utils/icmsSt.js).
export const CST_ICMS_SUPORTADOS_OPTS = [
  { codigo: '00', descricao: 'Tributada integralmente' },
  { codigo: '10', descricao: 'Tributada e com cobrança do ICMS por substituição tributária' },
  { codigo: '20', descricao: 'Com redução de base de cálculo' },
  { codigo: '30', descricao: 'Isenta ou não tributada e com cobrança do ICMS por ST' },
  { codigo: '40', descricao: 'Isenta' },
  { codigo: '41', descricao: 'Não tributada' },
  { codigo: '50', descricao: 'Suspensão' },
  { codigo: '51', descricao: 'Diferimento' },
  { codigo: '60', descricao: 'ICMS cobrado anteriormente por substituição tributária' },
  { codigo: '70', descricao: 'Com redução de base de cálculo e cobrança do ICMS por ST' },
  { codigo: '90', descricao: 'Outras' },
];
const CSOSN_SUPORTADOS = new Set(['102', '103', '202', '203', '300', '400', '500', '900']);
export const CSOSN_SUPORTADOS_OPTS = CSOSN_OPTS.filter(o => CSOSN_SUPORTADOS.has(o.codigo));
// F0e: CSOSN 101 e 201 (com permissão de crédito) só no CRT 1, com o percentual do mês
// cadastrado pelo escritório. O MEI (CRT 4) não dá crédito (LC 123, art. 23, § 4º, I).
const CSOSN_CRT1 = new Set([...CSOSN_SUPORTADOS, '101', '201']);
export const CSOSN_CRT1_OPTS = CSOSN_OPTS.filter(o => CSOSN_CRT1.has(o.codigo));

export const usaCsosn = regime => [1, 4].includes(Number(regime));

// Lista do regime da empresa. Regime ainda não carregado: lista vazia.
export function opcoesIcmsDoRegime(regime) {
  if (regime === null || regime === undefined || regime === '') return [];
  if (!usaCsosn(regime)) return CST_ICMS_SUPORTADOS_OPTS;
  return Number(regime) === 1 ? CSOSN_CRT1_OPTS : CSOSN_SUPORTADOS_OPTS;
}

export function codigoIcmsAceito(regime, codigo) {
  const c = String(codigo || '').trim();
  return opcoesIcmsDoRegime(regime).some(o => o.codigo === c);
}

export function produtoPrecisaRevisaoIcms(produto, regime) {
  const cst = String(produto?.cst_icms || '').trim();
  if (!cst || !opcoesIcmsDoRegime(regime).length) return false;
  return !codigoIcmsAceito(regime, cst);
}

// Padrão do regime (decisão do escritório, 23/10): Simples/MEI = CSOSN 102;
// Regime Normal e sublimite = CST 00. Regime não carregado: vazio.
export function icmsPadraoDoRegime(regime) {
  if (regime === null || regime === undefined || regime === '') return '';
  return usaCsosn(regime) ? '102' : '00';
}

// Código com que um item ou produto novo nasce: o padrão definido para a
// empresa (se valer para o regime), senão o padrão do regime. Fica visível e
// editável na tela; o backend não troca nada.
export function codigoIcmsInicial(regime, icmsPadraoEmpresa) {
  const emp = String(icmsPadraoEmpresa || '').trim();
  if (emp && codigoIcmsAceito(regime, emp)) return emp;
  return icmsPadraoDoRegime(regime);
}
